module.exports = __webpack_public_path__ + "static/media/RP-18.747b6b6d.pdf";